import { forwardTo } from "xstate"
import { defaultSendUserEvent, userEventsMachine } from "../user-events-machine"
import { ECommerceStateNodeConfig } from "./e-commerce-machine"
import { ECommerceContext } from "./e-commerce-machine-context"

export const userEventsConfig = (context: ECommerceContext): ECommerceStateNodeConfig => ({
    invoke: {
        id: "userEvents",
        src: userEventsMachine(
            {
                cruiseCode: context.cruiseCode,
                sessionId: context.sessionId,
                guests: context.guests,
                checkoutStatus: context.checkoutStatus,
                vsCode: context.vsCode,
                fareCards: context.fareCards,
                restoreCompleted: false,
            },
            defaultSendUserEvent(context.config.dotComApiBaseUrl),
        ),
    },
    on: {
        "*": { actions: forwardTo("userEvents") },
    },
})
